import { ref, computed, readonly } from "vue";
import { EditorMode, DEFAULT_CONFIG } from "../config";
import type { CanvasState } from "../types";

export function useCanvasState() {
  // 状态
  const mode = ref<EditorMode>(DEFAULT_CONFIG.MODE);
  const color = ref<string>("#000000");
  const fill = ref<string | undefined>(undefined);

  // 计算属性
  const isEditMode = computed(() => mode.value === EditorMode.PAINT);
  const isZoomMode = computed(() => mode.value === EditorMode.ZOOM);
  const isBrushTool = computed(() => mode.value === EditorMode.BRUSH);
  const isEraserTool = computed(() => mode.value === EditorMode.ERASER);

  // 方法
  const setMode = (newMode: EditorMode) => {
    mode.value = newMode;
  };

  const setColor = (newColor: string, _fill?: string) => {
    console.log(newColor, _fill);
    color.value = newColor;
    fill.value = _fill;
  };

  const getState = (): CanvasState => ({
    mode: mode.value,
    color: color.value,
  });

  const setState = (state: Partial<CanvasState>) => {
    if (state.mode !== undefined) mode.value = state.mode;
    if (state.color !== undefined) color.value = state.color;
  };

  return {
    // 状态
    mode: readonly(mode),
    fill,
    color,

    // 计算属性
    isEditMode,
    isZoomMode,
    isBrushTool,
    isEraserTool,

    // 方法
    setMode,
    setColor,
    getState,
    setState,
  };
}
